import React, { useEffect } from 'react';
import { Link } from "react-scroll";
import { FaMoon, FaSun, FaCode } from "react-icons/fa";
// import { Link } from "react-router-dom";

export const Navigation = ({ theme, onToggleTheme }) => {

  useEffect(() => {
    const handleScroll = () => {
      const nav = document.getElementById("main_nav");
      if (window.scrollY > 50) {
        nav.classList.add("scrolled");
      } else {
        nav.classList.remove("scrolled");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div>
      <nav id="main_nav" className="navbar navbar-expand-lg navbar-dark2">
        <div className="container-fluid">
          <Link to="/" className="navbar-brand">
            <FaCode size={24} style={{color: 'var(--color-coral)'}} />{' '}
            <span style={{color: 'var(--color-text-primary)', fontWeight: 600, fontSize: '16px'}}>erwin agpasa</span>
          </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbar">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              {/* <li className="nav-item"><Link className="nav-link" aria-current="page" to="/powerschool">Powerschool</Link></li>         */}
              <li className="nav-item"><Link className="nav-link" aria-current="page" smooth spy to="about">About</Link></li>
              <li className="nav-item"><Link className="nav-link" aria-current="page" smooth spy to="experience">Experience</Link></li>
              <li className="nav-item"><Link className="nav-link" aria-current="page" smooth spy to="project">Work</Link></li>
              <li className="nav-item"><Link className="nav-link" aria-current="page" smooth spy to="contact">Contact</Link></li>
              <li className="nav-item">
                <button
                  type="button"
                  className="btn btn-coral theme-toggle-btn"
                  onClick={onToggleTheme}
                  aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
                  title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
                >
                  {theme === 'dark' ? <FaSun aria-hidden="true" /> : <FaMoon aria-hidden="true" />}
                </button>
              </li>
              <li className="nav-item d-none d-sm-block"><a href="https://www.linkedin.com/in/erwinagpasa" target="_blank" rel="noreferrer" className="btn btn-coral">Resume</a></li>
            </ul>
          </div>
        </div>
      </nav>

    </div>
  )
}
